// @ts-ignore: allow importing CSS for side effects without type declarations
import "./splash-screen.css";

const SplashScreen = () => {
  return (
    <>
      <div className="splash-box">
        <div className="splash-text">
          <h1>LGEOM LAND MANAGEMENT SYSTEM (LAMS)</h1>
        </div>
      </div>
    </>
  );
};
export default SplashScreen;
